window.AnimatedChainAccordionItem = phrase => {
	return {
		val: phrase,
	};
};
